/**
 * Library for date and time manipulation
 * https://github.com/iamkun/dayjs#readme
 */

import Vue from 'vue';
import dayjs from 'dayjs';

const utc = require('dayjs/plugin/utc');
const timezone = require('dayjs/plugin/timezone');
const customParseFormat = require('dayjs/plugin/customParseFormat');
const isBetween = require('dayjs/plugin/isBetween');

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(customParseFormat);
dayjs.extend(isBetween);

// Add dayjs to Vue prototype to access dayjs in every component
Vue.prototype.$date = dayjs;
